module.exports = __webpack_public_path__ + "static/media/Finland.90512734.png";